import { Modal } from "react-bootstrap";

import "./fileViewer.css";
import { pdfjs } from "react-pdf";
import { useState } from "react";
import { Document, Page } from 'react-pdf';
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css"

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`;

export default function FileViewer({
  show, onHide, base64, fileExt
}: any) {



  const [numPages, setNumPages] = useState<number>();
  const [pageNumber, setPageNumber] = useState<number>(1);
  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages);
  }
  function nextPage() {
    setPageNumber((v) => ++v);
  }
  function prevPage() {
    setPageNumber((v) => --v);
  }
  const handleRightClick = (e: any) => {
    e.preventDefault(); // Prevents the default right-click context menu
  };
  if (show) {
    return (
      <>
        <Modal
          show={show}
          backdrop="static"
          size="lg"
          keyboard={false}
          enforceFocus={true}
          scrollable={true}
          onHide={() => {
            setPageNumber(1)
            onHide()
          }}
          dialogClassName="fileViewer"
        >
          <Modal.Header closeButton>

          </Modal.Header>
          <Modal.Body>
            {fileExt == "pdf" ? (<div style={{ width: "100%", height: "100%" }} onContextMenu={handleRightClick}>
              <button onClick={prevPage} disabled={pageNumber <= 1} className="buttonCss" style={{marginRight:'10px'}}>
                Previous
              </button>
              <button onClick={nextPage} disabled={pageNumber >= (numPages ?? -1)} className="buttonCss" style={{marginRight:'10px'}}>
                Next
              </button>
              <Document
                file={base64}
                onLoadSuccess={onDocumentLoadSuccess}
                className="my-react-pdf"
              >
                <Page pageNumber={pageNumber} renderTextLayer={false} />
              </Document>
              <p>
                Page {pageNumber} of {numPages}
              </p>
            </div>) : (<div style={{ width: "100%", height: "100%" }} onContextMenu={handleRightClick}><img src={base64} style={{ width: '100%', height: '100%' }} ></img></div>)}

          </Modal.Body>
          <Modal.Footer>
            <button
              className="buttonCss"
              onClick={() => {
                setPageNumber(1)
                onHide()
              }}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  } else {
    return <></>;
  }
}
